export default __webpack_public_path__ + "static/media/404.958559b1.jpg";